import axiosClient from './axiosClient';

const web = {
  getContent() {
    return axiosClient.get('/webdesktop');
  },
  add(data) {
    return axiosClient.post('/webdesktop/create');
  },
  update(id, data) {
    return axiosClient.update('/webdesktop/update/' + id, data);
  },
};
export default web;
